import { filterClientsByQuery as e } from "../helpers/filter-clients-by-query.js";
import { findClient as t } from "../helpers/find-client.js";
import { operationToHar as n } from "../helpers/operation-to-har/operation-to-har.js";
import { generateCodeSnippet as ee } from "../helpers/generate-code-snippet.js";
import { getCustomCodeSamples as te } from "../helpers/get-custom-code-samples.js";
import { getClients as r } from "../helpers/get-clients.js";
import { getSecrets as ne } from "../helpers/get-secrets.js";
import re from "./ExamplePicker.vue.js";
import i from "./HttpMethod.vue.js";
import { Fragment as a, computed as o, createBlock as s, createCommentVNode as c, createElementBlock as l, createElementVNode as u, createSlots as d, createTextVNode as f, createVNode as p, defineComponent as m, normalizeClass as ie, onBeforeMount as ae, openBlock as h, ref as g, renderSlot as _, toDisplayString as v, unref as y, useId as oe, watch as b, watchEffect as se, withCtx as x } from "vue";
import { ScalarButton as S } from "@scalar/components/button";
import { ScalarCard as C, ScalarCardFooter as ce, ScalarCardHeader as le, ScalarCardSection as w } from "@scalar/components/card";
import { ScalarCodeBlock as ue } from "@scalar/components/code-block";
import { ScalarCombobox as de } from "@scalar/components/combobox";
import { ScalarVirtualText as fe } from "@scalar/components/virtual-text";
import { freezeElement as pe } from "@scalar/helpers/dom/freeze-element";
import { ScalarIconCaretDown as T } from "@scalar/icons";
import { getResolvedRef as E } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { getOperationExamples as D, resolveOperationExamples as O } from "@scalar/workspace-store/helpers/operation-examples";
import { useExampleVisibility as k, useExternalExamples as A } from "@scalar/workspace-store/helpers/use-external-examples";
//#region src/code-example/components/CodeExample.vue?vue&type=script&setup=true&lang.ts
var j = ["innerHTML"], M = {
	key: 1,
	class: "text-c-2 flex h-full w-fit items-center px-0.5 py-0 text-base font-normal",
	"data-testid": "client-picker"
}, N = {
	key: 0,
	class: "text-c-2 p-4",
	role: "status"
}, P = {
	key: 1,
	class: "text-c-2 p-4",
	role: "status"
}, F = ["id"], I = {
	key: 0,
	class: "request-card-footer-addon"
}, L = {
	key: 1,
	class: "request-card-footer-start"
}, R = { class: "request-header" }, z = /*@__PURE__*/ m({
	__name: "CodeExample",
	props: {
		codeSampleUnavailable: { default: "No code sample available for this example." },
		clientPickerLabel: { default: "Change code sample language" },
		clientSearchLabel: { default: "Search clients" },
		codeSampleLabel: { default: "Code sample" },
		integration: {},
		clientOptions: {},
		selectedClient: {},
		selectedServer: { default: null },
		selectedContentType: {},
		selectedExample: {},
		eventBus: {},
		securitySchemes: { default: () => [] },
		method: {},
		path: {},
		operation: {},
		fallback: { type: Boolean },
		generateLabel: { type: Function },
		isWebhook: { type: Boolean },
		globalCookies: {},
		openapiVersion: {},
		requestBodyCompositionSelection: {}
	},
	emits: ["update:exampleKey"],
	setup(m, { emit: z }) {
		let B = z, V = o(() => {
			let e = E(m.operation.requestBody)?.content ?? {}, t = m.selectedContentType || Object.keys(e)[0];
			return t ? e[t]?.examples ?? {} : {};
		}), H = g(""), U = (e) => {
			let t = Object.keys(V.value);
			return e && t.includes(e) ? e : H.value && t.includes(H.value) ? H.value : t[0] ?? "";
		};
		ae(() => {
			H.value = U(m.selectedExample);
		}), b(() => m.selectedExample, (e) => {
			H.value = U(e);
		}), b(() => m.selectedContentType, () => {
			Object.keys(V.value).includes(H.value) || (H.value = U(m.selectedExample));
		}), se(() => {
			B("update:exampleKey", H.value);
		});
		let me = (e) => {
			H.value = e, m.eventBus.emit("workspace:update:selected-example", e);
		}, W = o(() => te(m.operation)), G = o(() => r(W.value.samples, m.clientOptions, W.value.label)), K = o(() => G.value.reduce((e, t) => e + t.options.length, 0)), q = g(t(G.value, m.selectedClient));
		b([() => m.selectedClient, G], ([e]) => {
			let n = t(G.value, e);
			n && (q.value = n);
		});
		let he = o(() => [m.clientPickerLabel, q.value?.title].filter(Boolean).join(": ")), ge = o(() => [m.codeSampleLabel, q.value?.title].filter(Boolean).join(": ")), J = g(null), _e = k(J), Y = A(() => D(m.operation, H.value, m.selectedContentType), () => _e.value), X = o(() => O(m.operation, H.value, m.selectedContentType, Y.resolve)), Z = o(() => Object.keys(V.value).length > 1), Q = o(() => {
			if (!m.isWebhook) return null;
			try {
				return n({
					operation: X.value,
					method: m.method,
					path: m.path,
					example: H.value,
					openapiVersion: m.openapiVersion,
					requestBodyCompositionSelection: m.requestBodyCompositionSelection,
					defaultDisabledParameters: !0
				});
			} catch (e) {
				return console.error("[webhookHar]", e), null;
			}
		}), $ = o(() => m.isWebhook ? Q.value?.postData?.text ?? "" : ee({
			defaultDisabledParameters: !0,
			includeDefaultHeaders: m.integration === "client",
			clientId: q.value?.id,
			customCodeSamples: W.value.samples,
			operation: X.value,
			method: m.method,
			path: m.path,
			contentType: m.selectedContentType,
			server: m.selectedServer,
			securitySchemes: m.securitySchemes,
			example: H.value,
			globalCookies: m.globalCookies,
			openapiVersion: m.openapiVersion,
			requestBodyCompositionSelection: m.requestBodyCompositionSelection
		})), ve = o(() => m.isWebhook ? ye.value : q.value?.lang), ye = o(() => {
			if (!Q.value?.postData) return "json";
			let e = Q.value.postData.mimeType;
			return e?.includes("json") ? "json" : e?.includes("xml") ? "xml" : e?.includes("yaml") || e?.includes("yml") ? "yaml" : e?.includes("text/plain") ? "text" : "json";
		}), be = o(() => ne(m.securitySchemes)), xe = (e) => {
			if (J.value) {
				let e = pe(J.value.$el);
				setTimeout(() => {
					e();
				}, 300);
			}
			q.value = e, e && m.eventBus.emit("workspace:update:selected-client", e.id);
		}, Se = o(() => ($.value?.length ?? 0) > 2e4), Ce = oe();
		return (t, n) => $.value === null || $.value || y(Y).pending.value ? (h(), s(y(C), {
			key: 0,
			ref_key: "elem",
			ref: J,
			class: "request-card dark-mode"
		}, {
			default: x(() => [
				p(y(le), { class: "pr-2.5" }, d({
					default: x(() => [
						n[1] ||= u("span", { class: "sr-only" }, "Request Example for", -1),
						p(i, {
							as: "span",
							class: "request-method",
							method: m.method
						}, null, 8, ["method"]),
						m.generateLabel ? (h(), l("span", {
							key: 0,
							innerHTML: m.generateLabel()
						}, null, 8, j)) : c("", !0),
						_(t.$slots, "header", {}, void 0, !0)
					]),
					_: 2
				}, [!m.isWebhook && K.value ? {
					name: "actions",
					fn: x(() => [K.value > 1 ? (h(), s(y(de), {
						key: 0,
						class: "max-h-80",
						filterFn: y(e),
						inputLabel: m.clientSearchLabel,
						modelValue: q.value,
						options: G.value,
						placement: "bottom-end",
						teleport: "",
						"onUpdate:modelValue": n[0] ||= (e) => xe(e)
					}, {
						default: x(() => [p(y(S), {
							"aria-label": he.value,
							class: "text-c-2 hover:text-c-1 flex h-full w-fit gap-1.5 px-0.5 py-0 text-base font-normal",
							"data-testid": "client-picker",
							variant: "ghost"
						}, {
							default: x(() => [f(v(q.value?.title) + " ", 1), p(y(T), {
								class: "ui-open:rotate-180 mt-px size-3 transition-transform duration-100",
								weight: "bold"
							})]),
							_: 1
						}, 8, ["aria-label"])]),
						_: 1
					}, 8, [
						"filterFn",
						"inputLabel",
						"modelValue",
						"options"
					])) : (h(), l("span", M, v(q.value?.title), 1))]),
					key: "0"
				} : void 0]), 1024),
				p(y(w), { class: "request-editor-section custom-scroll p-0" }, {
					default: x(() => [y(Y).pending.value ? (h(), l("div", N, [y(Y).failed.value ? (h(), l(a, { key: 0 }, [n[3] ||= f(" Could not load this example. ", -1), p(y(S), {
						size: "sm",
						variant: "ghost",
						onClick: y(Y).retry
					}, {
						default: x(() => [...n[2] ||= [f(" Retry ", -1)]]),
						_: 1
					}, 8, ["onClick"])], 64)) : (h(), l(a, { key: 1 }, [f("Loading example…")], 64))])) : $.value === null ? (h(), l("div", P, v(m.codeSampleUnavailable), 1)) : (h(), l("div", {
						key: 2,
						id: `${y(Ce)}-example`,
						class: "code-snippet"
					}, [Se.value ? (h(), s(y(fe), {
						key: 1,
						"aria-label": "Request code sample",
						containerClass: "custom-scroll scalar-code-block border rounded-b flex flex-1 max-h-screen",
						contentClass: "language-plaintext whitespace-pre font-code text-base p-2",
						lineHeight: 20,
						role: "region",
						text: $.value
					}, null, 8, ["text"])) : (h(), s(y(ue), {
						key: 0,
						class: "bg-b-2 h-full",
						content: $.value,
						hideCredentials: be.value,
						label: ge.value,
						lang: ve.value,
						lineNumbers: ""
					}, null, 8, [
						"content",
						"hideCredentials",
						"label",
						"lang"
					]))], 8, F))]),
					_: 1
				}),
				Z.value || t.$slots.footer || t.$slots["footer-start"] ? (h(), s(y(ce), {
					key: 0,
					class: ie(["request-card-footer bg-b-3", { "request-card-footer--wraps": !Z.value && t.$slots["footer-start"] }])
				}, {
					default: x(() => [Z.value ? (h(), l("div", I, [Object.keys(V.value).length ? (h(), s(re, {
						key: 0,
						examples: V.value,
						modelValue: H.value,
						"onUpdate:modelValue": me
					}, null, 8, ["examples", "modelValue"])) : c("", !0)])) : t.$slots["footer-start"] ? (h(), l("div", L, [_(t.$slots, "footer-start", {}, void 0, !0)])) : c("", !0), _(t.$slots, "footer", { exampleName: H.value }, void 0, !0)]),
					_: 3
				}, 8, ["class"])) : c("", !0)
			]),
			_: 3
		}, 512)) : m.fallback ? (h(), s(y(C), {
			key: 1,
			class: "request-card dark-mode"
		}, {
			default: x(() => [p(y(w), { class: "request-card-simple" }, {
				default: x(() => [u("div", R, [p(i, {
					as: "span",
					class: "request-method",
					method: m.method
				}, null, 8, ["method"]), _(t.$slots, "header", {}, void 0, !0)]), _(t.$slots, "footer", { exampleName: H.value }, void 0, !0)]),
				_: 3
			})]),
			_: 3
		})) : c("", !0);
	}
});
//#endregion
export { z as default };

//# sourceMappingURL=CodeExample.vue.script.js.map